var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { Icon } from '../../utils/icon-utils.js';
import { GGOBaseComponent } from '../ggo.base.component.js';
let MultiComboBoxComponent = class MultiComboBoxComponent extends GGOBaseComponent {
    static { this.properties = {
        label: { type: String },
        values: { type: Array },
        placeHolder: { type: String },
        selectedValues: { type: Array },
        // object && objectProperty are used to bind the combobox to an object property
        object: { type: Object }, // optional
        objectProperty: { type: String }, // optional
    }; }
    static get styles() {
        return [
            ...super.styles,
            css `
        .slds-combobox__input>span {
          font-size: .85rem;
          font-weight: 500;
        }
        .slds-combobox__input {
          cursor: pointer;
        }
        .slds-combobox__input:hover {
          border: solid .5px #1b96ff;
        }
        .slds-listbox__item:hover {
          color: #0176D3;
        }
        .slds-dropdown {
          margin-top: 1px;
        }
        `,
        ];
    }
    constructor() {
        super();
        this._states = [];
    }
    getLabelTemplate() {
        return this.label ? html ` <label class="slds-form-element__label" for="combobox" id="combobox-label">${this.label}</label> ` : nothing;
    }
    onOptionClicked(state) {
        let selectedLabels = this._states.filter((state) => state.checked).map((state) => state.label);
        this.selectedValues = this.values.filter((value) => selectedLabels.includes(this.getLabel(value)));
        if (this.object && this.objectProperty) {
            this.object[this.objectProperty] = this.selectedValues;
        }
        this.dispatchEvent(new CustomEvent('changed', { detail: this.selectedValues }));
        this.requestUpdate();
    }
    getLabel(cboption) {
        let label = '';
        if (typeof cboption === 'string') {
            label = cboption;
        }
        else if (typeof cboption === 'object') {
            if (cboption.alias)
                label = cboption.alias;
            else if (cboption.label)
                label = cboption.label;
            else if (cboption.name)
                label = cboption.name;
            else
                throw new Error('Combobox option must have a label or name property');
        }
        return label;
    }
    isEqual(cboption, selectedValue) {
        if (typeof cboption === 'string' && typeof selectedValue === 'string') {
            return cboption === selectedValue;
        }
        else if (typeof cboption === 'object' && typeof selectedValue === 'object') {
            if (cboption.id && selectedValue.id) {
                return cboption.id === selectedValue.id;
            }
            else if (cboption.value && selectedValue.value) {
                return cboption.value === selectedValue.value;
            }
            else if (cboption.name && selectedValue.name) {
                return cboption.name === selectedValue.name;
            }
            else if (cboption.label && selectedValue.label) {
                return cboption.label === selectedValue.label;
            }
            else if (cboption.alias && selectedValue.alias) {
                return cboption.alias === selectedValue.alias;
            }
        }
        else if (typeof cboption === 'string' && typeof selectedValue === 'object') {
            return cboption === this.getLabel(selectedValue);
        }
        else if (typeof cboption === 'object' && typeof selectedValue === 'string') {
            return this.getLabel(cboption) === selectedValue;
        }
        return false;
    }
    getOptionTemplate(state) {
        const is_selected_class = state.checked ? 'slds-is-selected' : '';
        let label = this.getLabel(state.label);
        return html `
      <li role="presentation" class="slds-listbox__item" data-value="${label}">
        <div class="slds-media slds-listbox__option slds-listbox__option_plain slds-media_small ${is_selected_class}" role="option">
          <span class="slds-media__body">
            <ggo-checkbox
              .checked="${state.checked}"
              @changed=${(e) => {
            state.checked = e.detail;
            this.onOptionClicked(state);
        }}
              >${label}</ggo-checkbox
            >
          </span>
        </div>
      </li>
    `;
    }
    render() {
        if (this.object && this.objectProperty) {
            this.selectedValues = this.object[this.objectProperty];
        }
        this._states = this.values.map((value) => {
            return {
                label: this.getLabel(value),
                checked: this.selectedValues?.some((sv) => this.isEqual(value, sv)) || false,
            };
        });
        console.log('STATES', this._states);
        const selectedLabel = this._states
            .filter((e) => e.checked)
            .map((e) => e.label)
            .join(', ');
        return html `
      <div class="slds-form-element">${this.getLabelTemplate()}</div>
      <div class="slds-form-element__control">
        <div class="slds-combobox_container">
          <div class="slds-combobox slds-dropdown-trigger slds-dropdown-trigger_undefined">
            <div class="slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right" role="none">
              <div
                role="combobox"
                tabindex="0"
                class="slds-input_faux slds-combobox__input"
                aria-labelledby="combobox-label"
                id="combobox-selected-value"
                aria-controls="listbox-id"
                aria-expanded="true"
                aria-haspopup="listbox"
              >
                <span class="slds-truncate" id="combobox-value">${selectedLabel}</span>
              </div>
              <span class="slds-icon_container slds-icon-utility-chevrondown slds-input__icon slds-input__icon_right">
                ${Icon.getSVGIconTag({
            icon: 'chevrondown',
            sprite: 'utility',
            classes: ['slds-icon', 'slds-icon_x-small', 'slds-icon-text-default'],
        })}
              </span>
            </div>
            <div
              id="listbox-id"
              class="slds-dropdown slds-dropdown_length-5 slds-dropdown_fluid"
              role="listbox"
              aria-label="{{Placeholder for Dropdown Items}}"
              tabindex="0"
              aria-busy="false"
            >
              <ul class="slds-listbox slds-listbox_vertical" role="presentation">
                ${this._states?.map((state) => {
            return this.getOptionTemplate(state);
        })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    `;
    }
};
MultiComboBoxComponent = __decorate([
    customElement('ggo-multi-combobox')
], MultiComboBoxComponent);
export { MultiComboBoxComponent };
export class ComboState {
}
